import { useGetOneDataset } from "#src/components/hooks/adapters/useDatasets";
import { useGetOneTransaction } from "#src/components/hooks/adapters/useTransactions";
import { KeyValuePanel } from "@validereinc/common-components";
import { Transactions } from "@validereinc/domain-controllers";
import { toTitleCaseString } from "@validereinc/utilities";
import React from "react";

const { selectFirstAndLastTransactionState } = Transactions.logic;
const { getSourceTypeDisplayLabel } = Transactions.view;

export const DataSetSubmissionDetailsPanel = ({
  transactionId,
}: {
  transactionId: string;
}) => {
  const transactionQuery = useGetOneTransaction({
    id: transactionId,
  });
  const datasetQuery = useGetOneDataset({
    id: transactionQuery.data?.data[0].dataset_id ?? "",
  });
  const { lastTransaction } = selectFirstAndLastTransactionState(
    transactionQuery.data?.data
  );

  return (
    <KeyValuePanel
      panelMaxColumnCount={2}
      panelKeyValueListProps={{ variant: "shaded" }}
      panelProps={{ title: "Submission Details" }}
      data={[
        {
          title: "Dataset",
          value: datasetQuery.data?.data.name
            ? toTitleCaseString(datasetQuery.data.data.name, {
                intent: "content",
              })
            : "-",
        },
        {
          title: "Dataset Import Type",
          value: datasetQuery.data?.data?.type
            ? toTitleCaseString(datasetQuery.data.data.type, { intent: "ui" })
            : "-",
        },
        {
          title: "Source",
          value: getSourceTypeDisplayLabel(
            lastTransaction?.source ?? "unknown"
          ),
        },
        {
          title: "Original Submission File Name",
          value: lastTransaction?.original_file_name ?? "-",
        },
        ...(datasetQuery.data?.data?.type === "tabular"
          ? [
              {
                title: "Total Rows in Submission",
                value: lastTransaction?.total_count ?? "-",
              },
            ]
          : []),
      ]}
    />
  );
};
